module.exports = __webpack_public_path__ + "static/media/16.82452a19.png";